import { PusdtCurrency, Usd1Currency, UsdtCurrency } from '@flipster/utils/constants/currency';

const getTradePathBase = (currency: string) => {
  switch (currency) {
    case PusdtCurrency:
      return 'trade/perpetual/BTCUSDT.PERP';
    case UsdtCurrency:
      return 'trade/perpetual/BTCUSDT.PERP';
    case Usd1Currency:
      return 'trade/perpetual/BTCUSD1.PERP';
    default:
      return 'trade/latest';
  }
};

export const getTradePath = (currency: string) => `/${getTradePathBase(currency)}`;
export const getTradePathForWebview = (currency: string) => getTradePathBase(currency);
